import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Stripe from 'app/apis/stripe';
import config from 'app/config';
import paths  from 'app/paths';


class StripePaymentElement extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isFormComplete: false,
      isSaving: false,
      didError: false,
    };

    this._paymentElement = null;
    this._elements = null;

    this.refStripeEl = React.createRef();

    this.onElementChange = this.onElementChange.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  componentDidMount() {
    this.mountStripe();
  }

  componentWillUnmount() {
    this._paymentElement.off('change', this.onElementChange);
  }

  get saveBtnDisabled() {
    if (this.state.isSaving) return true;
    if (!this.state.isFormComplete) return true;
    return false;
  }

  mountStripe() {
    const {clientSecret, name, email} = this.props;
    const elMount = this.refStripeEl.current;
    if (!elMount || !clientSecret) return;

    this._elements = Stripe.elements({clientSecret});
    const options = {layout: 'tabs'};
    if (name || email) {
      options.defaultValues = {billingDetails: {}};
      if (name) options.defaultValues.billingDetails.name = name;
      if (email) options.defaultValues.billingDetails.email = email;
    }
    this._paymentElement = this._elements.create('payment', options);
    this._paymentElement.on('change', this.onElementChange);
    this._paymentElement.mount(elMount);
  }

  onElementChange(event) {
    const isFormComplete = !!event.complete;
    this.setState({isFormComplete});
  }

  onClickSave() {
    const return_url = `${config.baseUrl}${paths.stripeRedirectSetupIntent()}`;
    const opts = {
      elements: this._elements,
      confirmParams: {return_url},      
    };
    this.setState({isSaving: true, didError: false});
    Stripe.confirmSetup(opts).then((resp) => {
      this.setState({isSaving: false});
    }).catch((error) => {
      console.error(error);
      this.setState({isSaving: false, didError: true});
    });
  }

  render() {
    const {isSaving, didError} = this.state;

    return (<>
      <div ref={this.refStripeEl} className="_mt-48">loading...</div>
      <div className="bform-actions">
        <div className="bform-actions-left" />
        <button className="btn blue" disabled={this.saveBtnDisabled} onClick={this.onClickSave}>{isSaving ? 'Saving...' : 'Save Bank Account'}</button>
      </div>
      {didError && (
        <p className="bform-error">Oops! Something went wrong. Please try again later.</p>
      )}
    </>);
  }

}

StripePaymentElement.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  name: PropTypes.string,
  email: PropTypes.string,
};

StripePaymentElement.defaultProps = {
};

export default StripePaymentElement;
